import CardBox                 from 'components/App/CardBox';
import React                   from 'react';
import { observer }            from 'mobx-react';
import { Button }              from 'antd';
import { Table }               from 'antd';
import { Empty }               from 'antd';
import { EditOutlined }        from '@ant-design/icons';
import { privateLayoutStore }  from 'stores/index';
import rights                  from 'utils/rights';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import { AppForm }             from 'components/App/AppForm';
import { showDashboardStore }  from 'stores/index';
import DemandConfigsForm       from 'forms/DemandConfigsForm';
import DemandTypeModel         from 'models/DemandTypeModel';
import DemandConfigModel       from 'models/DemandConfigModel';

@observer
class DemandConfigListBox extends React.Component {
  public render() {
    const { demandConfigCollection, showModel } = showDashboardStore;

    return (
      <CardBox
        content={
          <>
            {!demandConfigCollection.length ? (
              <Empty description={<FormattedMessageWrapper id="Demandes désactivées" />} />
            ) : (
              <Table
                columns={this.columns}
                dataSource={demandConfigCollection.models}
                loading={!demandConfigCollection.isLoaded || demandConfigCollection.isLoading}
                locale={{ emptyText: <FormattedMessageWrapper id="Demandes désactivées" /> }}
                pagination={false}
                rowKey={(model: DemandConfigModel) => model.id?.toString() || ''}
              />
            )}
          </>
        }
        extra={
          rights.for.demandConfig.edit && (
            <Button
              icon={<EditOutlined />}
              onClick={() => {
                AppForm.open(DemandConfigsForm, {
                  collection: demandConfigCollection,
                  onSuccess: () => {
                    privateLayoutStore.fetchData();
                    demandConfigCollection.list();
                  },
                  show: showModel,
                },
                {
                  okText: <FormattedMessageWrapper id="Enregistrer" />,
                  title: <FormattedMessageWrapper id="Paramétrage des demandes" />,
                });
              }}
            />
          )
        }
        loading={!demandConfigCollection.isLoaded || demandConfigCollection.isLoading}
        title={<FormattedMessageWrapper id="Paramétrage des demandes" />}
      />
    );
  }

  public renderDemandType = (demandConfig: DemandConfigModel) => {
    const { demandTypeCollection } = showDashboardStore;
    const demandType = demandTypeCollection.findBy('@id', demandConfig.demandType) as DemandTypeModel;
    return demandType ? demandType.label : '';
  };

  get columns() {
    return [
      {
        key: 'demandType',
        render: (_: string, demandConfig: DemandConfigModel) => this.renderDemandType(demandConfig),
        title: <FormattedMessageWrapper id="Type de demande" />,
      },
      {
        key: 'demandsAfter',
        render: (_: string, demandConfig: DemandConfigModel) =>
          demandConfig.demandsAfterDate && demandConfig.demandsAfterDate.format('DD/MM/YYYY'),
        title: <FormattedMessageWrapper id="A partir du" />,
      },
      {
        key: 'demandsBefore',
        render: (_: string, demandConfig: DemandConfigModel) =>
          demandConfig.demandsBeforeDate && demandConfig.demandsBeforeDate.format('DD/MM/YYYY'),
        title: <FormattedMessageWrapper id="Jusqu'au" />,
      },
      {
        key: 'surfaceMin',
        render: (_: string, demandConfig: DemandConfigModel) => demandConfig.surfaceMin,
        title: <FormattedMessageWrapper id="Surface min" />,
      },
    ];
  }
}

export default DemandConfigListBox;
